// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2CEcH","containerItemsCenter":"Skeleton_containerItemsCenter__39KPR"};